// extracted by css-extract-rspack-plugin
export default {"statistic":"ContentfulStatistics-module__statistic__G4Ki7z0"};